import { Plus } from '@phosphor-icons/react';
import { Link, NavLink } from 'react-router';
import { Wordmark } from '../../../shared/components/wordmark';
import { CREATE_TRANSACTION_HREF } from '../../../shared/constants/app.constant';
import { LedgerSwitcher } from '../../ledgers/components/ledger-switcher';
import { ThemeToggle } from '../../theme/components/theme-toggle';
import { MOBILE_NAV_ITEMS, type NavItem } from '../constants/nav.constant';
import { useCanRecord } from '../hooks/use-can-record';
import { ProfileMenu } from './profile-menu';

export function MobileHeader() {
  return (
    <header className="flex w-full min-w-0 flex-col gap-3 px-4 pt-[max(1rem,env(safe-area-inset-top))] lg:hidden">
      <div className="flex items-center justify-between">
        <Wordmark />
        <div className="flex items-center gap-1">
          <ThemeToggle />
          <ProfileMenu />
        </div>
      </div>
      <LedgerSwitcher />
    </header>
  );
}

export function BottomNav() {
  const canRecord = useCanRecord();
  const [dashboardItem, transactionsItem] = MOBILE_NAV_ITEMS;
  if (!dashboardItem || !transactionsItem) return null;

  return (
    <nav
      aria-label="Navigasi utama"
      className="fixed inset-x-0 bottom-0 z-20 border-t border-rule bg-card pb-[env(safe-area-inset-bottom)] lg:hidden"
    >
      <ul className="mx-auto flex max-w-md items-stretch justify-around">
        <BottomNavLink item={dashboardItem} />
        {canRecord ? (
          <li className="flex flex-1 items-center justify-center">
            <Link
              to={CREATE_TRANSACTION_HREF}
              aria-label="Catat transaksi"
              className="-mt-5 inline-flex size-14 items-center justify-center rounded-full bg-brass text-brass-ink shadow-lift"
            >
              <Plus size={24} weight="bold" aria-hidden="true" />
            </Link>
          </li>
        ) : null}
        <BottomNavLink item={transactionsItem} />
      </ul>
    </nav>
  );
}

function BottomNavLink({ item }: { readonly item: NavItem }) {
  const { to, label, icon: Icon, end } = item;
  return (
    <li className="flex-1">
      <NavLink
        to={to}
        end={end}
        className={({ isActive }) =>
          `flex min-h-14 flex-col items-center justify-center gap-0.5 text-xs ${isActive ? 'font-medium text-ink' : 'text-muted'}`
        }
      >
        <Icon size={22} weight="duotone" aria-hidden="true" />
        {label}
      </NavLink>
    </li>
  );
}

